import SystemPage from "@/components/feature/SystemPage";

export default function ForbiddenPage() {
  return (
    <SystemPage
      code="403"
      icon="ri-lock-2-line"
      title="Accès refusé"
      description="Vous n'avez pas les autorisations nécessaires pour consulter cette page. Contactez un administrateur si vous pensez qu'il s'agit d'une erreur."
      primaryLabel="Retour à l'accueil"
      primaryTo="/"
      secondaryLabel="Nous contacter"
      secondaryTo="/contact"
    />
  );
}